import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.projects.data.ProjectHelperFunctions.';
  public static readonly projectAbbrev = `${Id.prefix}projectAbbrev`;
}

export class LangProjectHelperFunctions {
  private constructor() {}
  public static projectAbbrev(): string {
    return interpolate(Id.projectAbbrev);
  }
}

export class ProjectHelperFunctionsModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.projectAbbrev,
      "{{glossary 'project-abbrev'}}",
      'Abbreviation for project, used as prefix in project numbers'
    );
  }
}
